<template>
  <section>
    <h1 class="text-h3 mb-8">
      Breakpoints
    </h1>
    <h2 class="text-h4 mb-4">
      Breakpoint table
    </h2>
    <v-simple-table class="mb-4">
      <thead>
        <tr class="text-left">
          <th
            v-for="header in headers"
            :key="header"
          >
            {{ header }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="breakpoint in breakpoints"
          :key="breakpoint.device"
        >
          <td>
            <v-icon
              left
            >
              {{ breakpoint.icon }}
            </v-icon>
            <span>{{ breakpoint.device }}</span>
          </td>
          <td>
            <strong>
              {{ breakpoint.code }}
            </strong>
          </td>
          <td>
            {{ breakpoint.type }}
          </td>
          <td>
            {{ breakpoint.range }}
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td
            class="text-caption text-center grey--text"
            colspan="4"
          >
            <em>
              * -{{ $vuetify.breakpoint.scrollBarWidth }}px on desktop for browser scrollbar
            </em>
          </td>
        </tr>
      </tfoot>
    </v-simple-table>
    <h2 class="text-h4 mb-4">
      Further reading
    </h2>
    <external-link href="https://vuetifyjs.com/en/features/breakpoints/">
      <strong>Breakpoint service</strong><br>
      <code>$vuetify.breakpoint</code>, custom breakpoint variables...
    </external-link>
    <external-link href="https://vuetifyjs.com/en/styles/display/">
      <strong>Display helper classes</strong><br>
      <code>.d-{value}</code>, <code>.d-{breakpoint}-{value}</code>...
    </external-link>
  </section>
</template>

<script>
export default {
  name: 'StylesBreakpoints',
  computed: {
    headers () {
      return [
        'Device',
        'Code',
        'Type',
        'Range'
      ]
    },
    breakpoints () {
      const breakpoint = this.$vuetify.breakpoint
      const thresholds = breakpoint.thresholds
      const scrollBarWidth = breakpoint.scrollBarWidth

      const md = thresholds.md - scrollBarWidth
      const lg = thresholds.lg - scrollBarWidth

      return [
        {
          icon: 'fa-regular fa-mobile',
          device: 'extra-small',
          code: 'xs',
          type: 'Small to large phone',
          range: `< ${thresholds.xs}px`
        },
        {
          icon: 'fa-regular fa-tablet',
          device: 'small',
          code: 'sm',
          type: 'Small to medium tablet',
          range: `${thresholds.xs}px > < ${thresholds.sm}px`
        },
        {
          icon: 'fa-regular fa-laptop',
          device: 'medium',
          code: 'md',
          type: 'Large tablet to laptop',
          range: `${thresholds.sm}px > < ${md}px*`
        },
        {
          icon: 'fa-regular fa-desktop',
          device: 'large',
          code: 'lg',
          type: 'Desktop',
          range: `${md}px > < ${lg}px*`
        },
        {
          icon: 'fa-regular fa-tv',
          device: 'extra-large',
          code: 'xl',
          type: '4k and ultra-wide',
          range: `> ${lg}px*`
        }
      ]
    }
  }
}
</script>
